import ReactDOM from "react-dom/client";
// import App from './App.tsx';
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./components/routes/index";
import Header from "./components/layout/header/Header";
// import Breadcrumb from "./components/breadcrumb/index.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReservationProvider } from './context/ReserationContext';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export const queryClient = new QueryClient();

root.render(
  <>
    <ToastContainer aria-label={undefined} />
    <ReservationProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
        <Header />
          <App />
        </BrowserRouter>
      </QueryClientProvider >
    </ReservationProvider>
  </>
);
